const faFolderImage = {
  prefix: 'fal',
  iconName: 'folder-image',
  icon: [
    512,
    512,
    [],
    'e18a',
    'M480 384c0 17.7-14.3 32-32 32L64 416c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l138.7 0c6.9 0 13.7 2.2 19.2 6.4l38.4 28.8c11.1 8.3 24.6 12.8 38.4 12.8L448 112c17.7 0 32 14.3 32 32l0 240zM64 448l384 0c35.3 0 64-28.7 64-64l0-240c0-35.3-28.7-64-64-64L298.7 80c-6.9 0-13.7-2.2-19.2-6.4L241.1 44.8C230 36.5 216.5 32 202.7 32L64 32C28.7 32 0 60.7 0 96L0 384c0 35.3 28.7 64 64 64zM184 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm47 42.5l-93.8 95.3c-5.9 6-9.2 14-9.2 22.4 0 17.6 14.3 31.9 31.9 31.9l192.2 0c17.6 0 31.9-14.3 31.9-31.9 0-8.4-3.3-16.4-9.2-22.4L281 202.5c-6.6-6.7-15.6-10.5-25-10.5s-18.4 3.8-25 10.5zM256 224c.8 0 1.6 .3 2.2 .9l93.6 95.1-191.7 0 93.6-95.1c.6-.6 1.4-.9 2.2-.9z',
  ],
};
export default faFolderImage;
